import { KpiCard } from '@evi/ui';
import type { OperatorDashboardData } from '@evi/shared';
import { chargerDelta } from './_lib';

export default function KpiChargers({ summary }: { summary: OperatorDashboardData | undefined }) {
  return (
    <KpiCard
      label="Chargers online"
      value={summary ? `${summary.network.online}/${summary.network.total}` : '—'}
      delta={summary ? chargerDelta(summary) : undefined}
    />
  );
}
